/*
 * File: ProtectedRoutes.tsx
 * Project: a-a
 * File Created: Thursday, 10th October 2024 8:41:02 pm
 * Author: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Last Modified: Thursday, 28th August 2025 8:59:27 pm
 * Modified By: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Copyright 2020 - 2024 Mutual Mobile, Mutual Mobile
 */
//deploy .....................

import { Navigate, useLocation, useParams } from 'react-router-dom';
import React, { ReactElement, useEffect, useState } from 'react';
import RoutePaths from './RoutePaths';
import { AuthService } from '../service/auth.service';

export const ProtectedRoute = ({ children }: { children: ReactElement }) => {
  const token = sessionStorage.getItem('user-token') || '';
  let accessToken = { AccessToken: '' };
  // const params = useParams();
  const location = useLocation();
  console.log(location);
  // console.log(token);
  if (token) {
    accessToken = JSON.parse(token);
  }
  let authState;
  if (!accessToken?.AccessToken) {
    authState = false;
  } else {
    authState = true;
  }

  // useEffect(() => {
  //   console.log('redirect', location);
  //   location?.search && login();
  // }, [location?.search]);

  if (!authState && !location?.search) {
    return <Navigate to={RoutePaths.Root} />;
  }

  // If still loading, don't render the children, wait until the login is done

  // Once authenticated and login is complete, render the protected children
  return children;
};

export const ValidateEmailRoute = ({ children }: { children: ReactElement }) => {
  const email = sessionStorage.getItem('email');
  if (email === null) {
    return <Navigate to={RoutePaths.Root} />;
  } else {
    return children;
  }
};

export const ValidateNewUserRoute = ({ children }: { children: ReactElement }) => {
  const email = sessionStorage.getItem('register-user');
  console.log(email);
  if (email) {
    return children;
  } else {
    return <Navigate to={RoutePaths.Root} />;
  }
};

export async function loader({ request, params }: { request: any; params: any }) {
  const url = new URL(request.url); // Get full URL from the request
  const search = url.searchParams.get('code'); // Get the 'code' query parameter
  console.log(request, search);
  const token = sessionStorage.getItem('user-token') || '';
  let accessToken = { AccessToken: '' };

  if (token) {
    accessToken = JSON.parse(token);
  }
  // if (search) {
  //   try {
  //     const res = await AuthService.ms_team_events(search);
  //     console.log(res);
  //   } catch (err: any) {
  //     console.log(err);
  //   }
  // }
  // console.log(process.env.REACT_APP_REDIRECT || '');
  if (search && !accessToken?.AccessToken) {
    try {
      const res = await AuthService.ms_login(search || '', process.env.REACT_APP_REDIRECT || '');
      console.log(res?.httpStatusCode == 200, res);
      if (res) {
        const huddleInfo = await AuthService.huddle_info(res.AuthenticationResult?.IdToken);
        console.log(
          huddleInfo,
          'huddle info',
          huddleInfo?.isSlackLinked,
          JSON.stringify(huddleInfo?.isSlackLinked),
        );

        sessionStorage.setItem('SFToken', JSON.stringify(huddleInfo?.isSFLinked));

        sessionStorage.setItem('isSlackConnected', JSON.stringify(huddleInfo?.isSlackLinked));
        sessionStorage.setItem('current-user', res.email);
        sessionStorage.setItem('ms_login', res.isMSLogin);
        sessionStorage.setItem('user-token', JSON.stringify(res.AuthenticationResult));
        sessionStorage.setItem('user-name', `${res.firstName}`);
        const now = new Date();
        const fiveHoursLater = new Date(now.getTime() + 60 * 60 * 1000 * 5);
        const oneHourLater = new Date(now.getTime() + 60 * 60 * 1000);
        // Save in sessionStorage as a string
        sessionStorage.setItem('loginExpiry', fiveHoursLater.toString());
        sessionStorage.setItem('refreshToken', oneHourLater.toString());
        // navigate(RoutePaths.Home);
      }
    } catch (err: any) {
      console.log(err);
    }
  }
  return null;
  // ('');
}
